module.exports = __webpack_public_path__ + "img/check_mark.2b13ea40.svg";